<button class="button button-quick-actions" (click)="toggleQuickActions()">
  <span class="button-plus" [ngClass]="{ 'button-x': quickActionsOpen }"></span>
</button>

<div class="menu-container" *ngIf="quickActionsOpen">
  <a
    *ngFor="let quickAction of quickActions"
    class="quick-action"
    (click)="toggleQuickActions(quickAction)"
    [routerLink]="quickAction.route"
    [queryParams]="quickAction.queryParams">
    <span class="quick-action-text">
      <svg-icon class="icon-quick-action" [src]="quickAction.svgUrl"></svg-icon>
      {{ quickAction.text }}
    </span>
  </a>
</div>
